import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;

/**
 * Log an error to PostHog as an `app_error` event.
 * Every error includes a `metric` field for easy searching and dashboard filtering.
 *
 * Sends both:
 *  1. A PostHog analytics event (`app_error`) for dashboards
 *  2. An OTLP log record (via fetch) for the PostHog Logs tab
 *
 * Metrics:
 *   upload_error, generation_error, export_error, sign_in_error,
 *   save_to_library_error, export_from_library_error, deck_delete_error,
 *   deck_save_error, stripe_error, billing_portal_error
 */
export function captureError(
  metric: string,
  error: unknown,
  properties?: Record<string, unknown>,
) {
  const errorMessage = error instanceof Error ? error.message : String(error);

  // 1. PostHog analytics event (for dashboards)
  posthog.capture('app_error', {
    metric,
    error_message: errorMessage,
    source: 'frontend',
    ...properties,
  });

  // 2. OTLP log (for PostHog Logs tab)
  if (POSTHOG_KEY) {
    const attrs = (obj: Record<string, unknown>) =>
      Object.entries(obj)
        .filter(([, v]) => v !== undefined)
        .map(([k, v]) => ({ key: k, value: { stringValue: String(v) } }));

    fetch('https://us.i.posthog.com/i/v1/logs', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${POSTHOG_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        resourceLogs: [{
          resource: {
            attributes: [{ key: 'service.name', value: { stringValue: 'slidetoanki-web' } }],
          },
          scopeLogs: [{
            scope: { name: 'slidetoanki-web' },
            logRecords: [{
              timeUnixNano: String(Date.now() * 1_000_000),
              severityNumber: 17, // ERROR
              severityText: 'ERROR',
              body: { stringValue: `[frontend] [${metric}] ${errorMessage}` },
              attributes: attrs({ metric, error_message: errorMessage, source: 'frontend', ...properties }),
            }],
          }],
        }],
      }),
    }).catch(() => {});
  }
}
